import {
  useSelectedNumberByVariableKey,
  useSelectedValueAttributeByKey,
  useSelectedValueByVariableKey,
} from '@k3/core'
import { Box, Typography, Divider } from '@mui/material'
import { useCellCountAndOffset } from '../three/scene/useCellCountAndOffset'
import { useDimensions } from '../three/scene/useDimensions'
import { Keys } from '../three/utility/utils'

const sxStyles = {
  root: {
    my: 2,
    overflow: 'hidden',
  },
  labelContainer: {
    padding: 1,
    maxHeight: 32 * 8,
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
}

const InfoItem = ({ children, ...props }: { children: React.ReactNode }) => (
  <Typography
    gutterBottom
    color="text.primary"
    {...props}
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '0.9rem',
      padding: '0 5px',
    }}
  >
    {children}
  </Typography>
)

export const PowerCalculation = () => {
  const { length, width, countWidth, countLength } = useCellCountAndOffset()
  const { fullThickness, panelDimensions } = useDimensions()

  const cellCount = countWidth * countLength
  const qm = (length * width).toFixed(2)

  const cellPower =
    useSelectedNumberByVariableKey(Keys.CellPower.Variable) ?? 5.6

  const CTMattribute = useSelectedValueAttributeByKey('frontGlassColor', 'CTM')
  const CTMLoss = (100.0 - parseFloat(CTMattribute?.value as string)) / 100.0

  const product = useSelectedValueByVariableKey(Keys.EFormType.Variable)
  const ausführung = useSelectedValueByVariableKey(Keys.BackGlassVSG.Variable)
  const zellbelegung =
    100 -
    ((cellCount *
      (Math.round(panelDimensions * panelDimensions * 10000) / 10000)) /
      parseFloat(qm)) *
      100

  return (
    <Box component="div" sx={sxStyles.root}>
      <Divider />
      <Box component="div" sx={sxStyles.labelContainer}>
        <InfoItem>
          {'Produkt:'}
          <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>
            {product?.label}
          </span>
        </InfoItem>

        {ausführung?.key === 'selected' && (
          <InfoItem>
            {'Ausführung:'}
            <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>{'VSG'}</span>
          </InfoItem>
        )}

        <InfoItem>
          {'Länge x Breite:'}
          <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>
            {length * 1000} {' mm x '} {width * 1000} {'mm'}
          </span>
        </InfoItem>

        <InfoItem>
          {'Fläche:'}
          <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>
            {qm + ' m²'}{' '}
          </span>
        </InfoItem>

        <InfoItem>
          {'Zellenanzahl:'}
          <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>
            {cellCount + ' Stück'}
          </span>
        </InfoItem>

        <InfoItem>
          {'Leistung:'}
          <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>
            {Math.floor(cellCount * cellPower * CTMLoss) + ' Wp nom'}
          </span>
        </InfoItem>

        {product?.key === 'clear' && (
          <InfoItem>
            {'Transparenzgrad:'}
            <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>
              {zellbelegung.toFixed(0)}%
            </span>
          </InfoItem>
        )}
        <InfoItem>
          {'Glasdicke:'}
          <span style={{ flex: '0 1 50%', fontWeight: 'bold' }}>
            {fullThickness * 1000} mm
          </span>
        </InfoItem>
      </Box>
    </Box>
  )
}
